import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { GetResponse, GetResult } from "@/api/color-information/response";
import * as ColorInformationAPI from "@/api/color-information";
import { isSuccess } from "@/api/response";
import { GetRequest } from "@/api/color-information/request";

const MODULE_NAME = "color-information/detail";

/**
 * アプリレイアウトカラー設定情報取得API（/get-colorInfomation-detail）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getResponse: GetResponse = {} as GetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getDetail() {
    return this.getResponse.results || ({} as GetResult);
  }

  // MutationActions
  @MutationAction
  async get(getRequest: GetRequest) {
    const getResponse = await ColorInformationAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as GetResponse
    };
  }
}

export default getModule(Get);
